export default {
  heading: "Better business pricing",
  subheading: "Get business-grade speeds without the premium price.",
  items: [
    {
      icon: "money-sign",
      heading: "Free installation",
      copy: "For a limited time, get free expert installation."
    },
    {
      icon: "subtract",
      heading: "No annual contract",
      copy: "Get connected with no data caps or overage charges."
    },
    {
      icon: "router",
      heading: "Router included with service",
      copy: "Keep employees and customers connected with a Next-Gen Wi-Fi 6E router, included in your plan."
    }
  ]
}
